module.exports = __webpack_public_path__ + "static/mobile-calendar-cc7b138439059817255a65f214ae0790.png";